export const containerBudgetStyle = ({ palette = {} }) => ({
  '& .container-budget, & .search-bid__container': {

    '& span': {
      color: palette.neutralPrimary,
    },

    '& .form-control-static': {
      minHeight: 'unset',
    },

    '& .input-group-addon': {
      background: palette.white,
      border: 0,
      color: palette.neutralPrimary,
      padding: '6px 6px 6px 12px',
    },

    '& .lifetime-currency': {
      padding: '6px 12px 6px 12px',
    },

    '& .col-sm-3': {
      display: 'table',
      paddingRight: 0,
      paddingLeft: 0,
    },

    '& .col-sm-12': {
      paddingLeft: 0,
    },

    '& .margin-rt-five': {
      paddingLeft: 28,
    },

  },

});
